import { Grid, Typography } from '@mui/material';
import { formatCurrency } from '@utils/formater';
import { DecimalDigits } from '@constants/enums';
import { useTranslation } from 'react-i18next';
import { Alert, Button } from 'reactstrap';

interface MethodValidationProps {
  newAccountBalance: number;
  currencyBalance: string;
  amount: string;
  currency: string;
  setStep: (step: number) => void;
}

const MethodValidation = ({
  newAccountBalance,
  currencyBalance,
  amount,
  currency,
  setStep,
}: MethodValidationProps) => {
  const { t } = useTranslation();
  return (
    <Grid container rowSpacing={2} columnSpacing={{ xs: 2, sm: 2, md: 3 }}>
      <Grid item xs={12} className="flex justify-center">
        <div className="text-center m-auto w-full w-100">
          <Typography variant="h6" className="!my-4 text-center">
            {t('paymentMethods')}
          </Typography>
          <div className="">
            <Typography className="radio-label-1">
              {t('noAdditionalCost')}
            </Typography>
            <Typography className="radio-label-2">
              {t('balanceYourAccount')}
            </Typography>
            <Typography
              variant="subtitle2"
              className="radio-label-amount max-w-[150px] md:max-w-[400px] !mb-2 p-1"
            >
              {`${currencyBalance} - ${formatCurrency(
                amount,
                DecimalDigits.DEFAULT_DIGITS,
                DecimalDigits.DEFAULT_MIN_DIGITS,
                currency
              )} = ${formatCurrency(
                newAccountBalance,
                DecimalDigits.DEFAULT_DIGITS,
                DecimalDigits.DEFAULT_MIN_DIGITS,
                currency
              )}`}{' '}
              {currency}
            </Typography>
            {newAccountBalance < 0 && (
              <Alert severity="warning" className="mb-2 text-left">
                <span className="m-0 ml-1 font-bold">
                  {t('noteFunding', {
                    AMOUNT_CHANGE_CONTENT: `${formatCurrency(
                      -newAccountBalance
                    )}`,
                  })}
                </span>
              </Alert>
            )}
          </div>
        </div>
      </Grid>
      <Grid item xs={12} className="flex justify-around">
        <Button
          color="primary"
          className="w-1/2"
          onClick={() => setStep(1)}
          disabled={newAccountBalance < 0}
        >
          {t('continue')}
        </Button>
      </Grid>
    </Grid>
  );
};

export default MethodValidation;
